
@if (customSellerInfo) {
  <div class="mb-3">
    <div>
      <!-- No heading of its own: the presence follows straight on from the
           regulatory details of the seller info page (#103). -->
      <div class="mb-2">
        @if (imageFile || customSellerInfo.brandInfoText) {
          <div class="card">
            @if (imageFile) {
              <img [src]="imageFile" class="card-img-top" alt="" />
            }
            <div class="card-body">
              <div class="example-config" [innerHTML]="customSellerInfo.brandInfoText"></div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
